import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CdkDragDrop, moveItemInArray, CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-dragable-list',
    templateUrl: './dragable-list.component.html',
    styleUrls: ['./dragable-list.component.scss'],
    imports: [NgIf, CdkDropList, NgFor, CdkDrag]
})
export class DragableListComponent implements OnInit {
  @Input() items;
  @Input() hideButton = false;
  @Input() actionBtnText = 'Crear';
  @Output() arrayReady = new EventEmitter();
  @Output() deleteRow = new EventEmitter();
  routeTitle: any;
  parent: any;


  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.routeTitle = this.route.snapshot.data['title'];
    this.parent = this.route.snapshot.data['parent'];
  }

  ngOnInit() {
  }

  onDrop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.items, event.previousIndex, event.currentIndex);
    this.updateOrder();
  }

  goToEdit(id: number) {
    this.router.navigate([`${this.parent}/edit/${id}`]);
  }

  goToAdd() {
    this.router.navigate([`${this.parent}/add`]);
  }

  delete(id: number) {
    this.deleteRow.emit(id);
  }

  updateOrder() {
    const ordered = this.items.map((item, index) => {
      return {
        id: item.id,
        order: index + 1
      };
    });
    this.arrayReady.emit(ordered);
  }
}
